import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import GameComponent from '../components/Game'
import GameModel from '../models/Game'
import Hero from '../models/Hero'
import Chance from '../utils/Chance'
import { assign } from '../utils/Common'

interface IGameParams {
  gameId: string
  width: string
  height: string
}

interface IGameState {
  game: GameModel
}

export default class Game extends React.Component<RouteComponentProps<IGameParams>, IGameState> {
  constructor(props: RouteComponentProps<IGameParams>) {
    super(props)

    Chance.seed = props.match.params.gameId

    this.state = { game: this.newGame() }
  }

  createHero() {
    return assign(new Hero(), {name: 'Hero'})
  }

  newGame() {
    return new GameModel(this.createHero(), +this.props.match.params.width || 4, +this.props.match.params.height || 4)
  }

  render() {
    return <GameComponent model={this.state.game} />
  }
}
